import {SET_CURRENT_USER} from "src/redux/types";

export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user: user
  };
}
